import React, { useContext } from 'react';

import FilterInput from '../../../components/filter-input';
import { id } from '../../../../filters/options/recipient-name';

import { AdvancedSearchOrderContext } from '../../context';
import messages from './messages';

const RecipientNameFilter = () => {
  const { filters, updateFilter } = useContext(AdvancedSearchOrderContext);

  return <FilterInput filters={filters} id={id} labelMessage={messages.recipientName} updateFilter={updateFilter} />;
};

export default RecipientNameFilter;
